import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import { trackEvent } from '@xingternal/hops-tracking';
import { IconMore } from '@xingternal/icons';
import { Menu, SingleSelect } from '@xingternal/menu';
import { usePopOver } from '@xingternal/pop-over';

import * as S from './meatball-menu-component.styles';

const MeatballMenu = ({ className, menuOptions, intl }) => {
  const popOver = usePopOver();
  const onButtonClick = () => {
    if (!popOver.show) {
      trackEvent('PropTrackAction', { PropTrackAction: 'jobs_meatball_menu_open' });
      popOver.handleShow();
    } else {
      popOver.handleHide();
    }
  };

  return (
    <div className={className}>
      <S.MeatballButton
        size="medium"
        data-testid="meatball-menu-button"
        data-cy="meatball-menu-button"
        onClick={onButtonClick}
        icon={IconMore}
        aria-label={intl.formatMessage({ id: 'BUTTON_MORE' })}
        innerRef={popOver.triggerRef}
      />
      <Menu
        show={popOver.show}
        triggerRef={popOver.triggerRef}
        onOutsideClick={popOver.handleHide}
        showCloseButton={false}
      >
        {menuOptions.map((option) => {
          const onClick = () => {
            popOver.handleHide();
            option.onClick && option.onClick();
          };

          return (
            <SingleSelect
              value={option.messageKey}
              key={option.messageKey}
              {...(option.href && { href: option.href, target: '_blank' })}
              {...(option.fencedInSoftLogin && { 'data-soft-login-fenced': true })}
              onClick={onClick}
            >
              <FormattedMessage id={option.messageKey} />
            </SingleSelect>
          );
        })}
      </Menu>
    </div>
  );
};

MeatballMenu.propTypes = {
  className: PropTypes.string,
  menuOptions: PropTypes.array.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(MeatballMenu);
